import useDataLoader from './lib/dataLoader';

export { useDataLoaderNew } from './lib/dataLoader';

export default useDataLoader;
